const featuresPay = {
    featureTitle: 'Verilere Dayalı İş Kararları Alın',
    featureDescription:
        'Hangi ürünlerin en çok satıldığını ve en yüksek kârı sağladığını öğrenin, finansal raporlara istediğiniz zaman, istediğiniz yerden erişin. İşletmeniz avucunuzun içinde!',
    featureButton: "Premium Abonelik",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'Başlangıç fiyatı',
    featureEndingText: 'Bin',

    features: [
        {
            title: 'Sınırsız Ürün',
            description: 'Sahip olduğunuz tüm ürünleri limitsiz ekleyin.'
        },
        {
            title: 'Sınırsız Personel',
            description: 'İşletmeye limitsiz Personel/Yönetici ekleyin.'
        },
        {
            title: 'Sınırsız Geçmiş',
            description: 'Eski stok kayıtlarındaki değişiklikleri limitsiz görüntüleyin.'
        },
        {
            title: 'Geçmiş Filtreleme',
            description: 'Geçmişi tür, kategori, personel ve tarihe göre kolayca görüntüleyin.'
        },
        {
            title: 'Excel\'e İndir',
            description: 'Stok kayıt geçmişini tek tıkla Microsoft Excel\'e aktarın.'
        },
        {
            title: 'PDF\'e İndir',
            description: 'Güncel ürün ve stok listesini tek tıkla PDF olarak alın.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Daha iyi stok yönetimi için birden fazla depo oluşturun.'
        },
        {
            desc: 'Ürünleri belirli konumlara atayın.'
        },
        {
            desc: 'Depolar arası stok seviyelerini izleyin.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Beden, renk veya malzeme varyantları ekleyin.' },
        { desc: 'Her varyant için stok seviyesi belirleyin.' },
        { desc: 'Depolar arası takibi yapın.' }
    ]
}
export default featuresPay